import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyRequisitions, SupplyRequisition } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './requisitionsModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplyRequisition> useData={useSupplyRequisitions} config={config} />;
};

export default List;
